import { current } from "@reduxjs/toolkit";
import React, { useEffect, useState, memo, FC } from "../../../../lib/teact/teact";
import Button from "../../../ui/Button";
import { LotScreenSettings } from "../../config/uiconfig";
import BaoCaoLaiLoNgay from "./baoCaoLaiLoNgay";
import DropdownMenu from "../../../ui/DropdownMenu";
import MenuItem from "../../../ui/MenuItem";
import BaoCaoDoanhThu from "./baoCaoDoanhThu";
import CongNoMain from "./congNoMain";
import TongHopNhanChuyen from "../Report/tongHopNhanChuyen";

type OwnProps = {
    backToScreen: LotScreenSettings;
    onChangeScreen: (screen: LotScreenSettings) => void;
}
enum ReportID {
    TongHopNgay,
    BaoCaoDoanhThu,
    CongNo,
    TongHopNhanChuyen,
}
const MainReport: FC<OwnProps> = ({
    backToScreen,
    onChangeScreen,
}) => {
    const [state, setState] = useState({
        currentReport: ReportID.TongHopNgay,
        currentReportTitle: "Báo cáo lãi lỗ",
    })
    function changeCurrentReport(rptId: ReportID) {

        let title = "Báo cáo"
        switch (rptId) {
            case ReportID.BaoCaoDoanhThu:
                title = "Báo cáo lãi lỗ theo kỳ"
                break;
            case ReportID.CongNo:
                title = "Báo cáo công nợ"
                break;
            case ReportID.TongHopNgay:
                title = "Báo cáo lãi lỗ ngày"
                break;
            case ReportID.TongHopNhanChuyen:
                title = "Tổng hợp Nhận/Chuyển"
                break;
        }
        setState(prev => ({ ...prev, currentReport: rptId, currentReportTitle: title }))
    }
    return (
        <div className="form-main">
            <div className="form-header">
                <div className="form-header left-panel">
                    <Button
                        round
                        size="default"
                        color="translucent"
                        onClick={() => {
                            onChangeScreen(backToScreen)
                        }}
                    //className={buildClassName(styles.headerButton, styles.firstButton)}
                    //ariaLabel={lang(isFullscreen ? 'AccExitFullscreen' : 'AccSwitchToFullscreen')}
                    >
                        <i
                            className='icon icon-arrow-left'
                            aria-hidden
                        />
                    </Button>
                    <div>{state.currentReportTitle}</div>
                </div>
                <div className=" form-header right-panel">
                    <DropdownMenu positionX="right" >
                        <MenuItem onClick={() => changeCurrentReport(ReportID.TongHopNgay)}>Báo cáo lãi lỗ hàng ngày</MenuItem>
                        <MenuItem onClick={() => changeCurrentReport(ReportID.BaoCaoDoanhThu)}>Báo cáo lãi lỗ theo thời gian</MenuItem>
                        <MenuItem onClick={() => changeCurrentReport(ReportID.CongNo)}>Báo cáo Công nợ, thu bù</MenuItem>
                        <MenuItem onClick={() => changeCurrentReport(ReportID.TongHopNhanChuyen)}>Tổng hợp nhận/chuyển</MenuItem>
                    </DropdownMenu>
                </div>
            </div>
            {
                state.currentReport == ReportID.TongHopNgay &&
                <BaoCaoLaiLoNgay backToScreen={LotScreenSettings.MAIN_REPORT_SCREEN} onChangeScreen={onChangeScreen}></BaoCaoLaiLoNgay>
            }
            {
                state.currentReport == ReportID.BaoCaoDoanhThu &&
                <BaoCaoDoanhThu></BaoCaoDoanhThu>
            }
            {
                state.currentReport == ReportID.CongNo &&
                <CongNoMain></CongNoMain>
            }
            {
                state.currentReport == ReportID.TongHopNhanChuyen &&
                <TongHopNhanChuyen></TongHopNhanChuyen>
            }
        </div>
    )
}

export default memo(MainReport)